import * as React from 'react';

import { reduxForm } from 'redux-form';
import { Card } from 'material-ui/Card';
import { compose, withHandlers, withState } from 'recompose';
import Lock from 'material-ui/svg-icons/action/lock';
import { get } from 'lodash';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Loader } from '@components/loader';
import { withConfiguration } from '@components/hoc/withConfiguration';
import { withNotifications } from '@components/hoc/withNotifications';
import * as T from '@modules/login/_loginTypes';
import { withRouter } from 'react-router';
import { signIn, kerberosSignIn } from '@modules/login/_loginActions';
import {
  isPasswordChangeExtensionEnabled,
  isPasswordChangeRequired,
  PASSWORD_CHANGE_PATH
} from '@modules/login/_passwordChange';

import { Grid, Row, Col } from 'react-flexbox-grid';
import { InputField, Input } from '@components/form';
import { required } from '@utils/validators';
import { configurationValues } from '@components/provider/configuration/_configurationConstants';

const enhance = compose<T.LoginFormProps, T.LoginFormProps>(
  withConfiguration({}),
  withNotifications({ signIn, kerberosSignIn }),
  withState('loader', 'setLoader', false),
  withRouter,
  withHandlers({
    handleKerberosLogin: ({ setLoader, kerberosSignInNotify, config: { extensions } }) => async () => {
      setLoader(true);
      await kerberosSignInNotify(isPasswordChangeExtensionEnabled(extensions));
      setLoader(false);
    },
    onSubmit: ({
      history,
      signInNotify,
      setLoader,
      config: {
        extensions
      }
    }) => async data => {
      const { login } = extensions;
      const isLdap =
        login === configurationValues.config.extensions.login.ldap ||
        login === configurationValues.config.extensions.login.kerberosLdap;
      setLoader(true);
      const signInUrl = isLdap ? '/metropolis/api/ldap/login' : '/metropolis/api/basic/login';
      if (await signInNotify(data.username, data.password, signInUrl, isPasswordChangeExtensionEnabled(extensions))) {
        history.push(isPasswordChangeRequired() ? PASSWORD_CHANGE_PATH : '/');
      }
      setLoader(false);
    }
  }),
  reduxForm({
    form: 'module-login'
  })
);

const View: React.SFC<T.LoginFormProps> = props => (
  <div>
    {props.loader && <Loader />}
    <form className="login" onSubmit={props.handleSubmit}>
      <Card className="login-card">
        <div className="login-card-inside">
          <div className="login-header">
            <Lock color="grey" style={{ width: 40, height: 40 }} />
          </div>
          <Grid fluid={true}>
            <Row>
              <Col xs={12}>
                <InputField component={Input} name="username" label="Přihlašovací jméno" validate={[required]} />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <InputField component={Input} name="password" label="Heslo" type="password" validate={[required]} />
              </Col>
            </Row>
          </Grid>
          <div className="login-buttons">
            <Button className="login-button" type="submit" label="Přihlásit" primary={true} />
            {get(props, 'config.extensions.login') === configurationValues.config.extensions.login.kerberosLdap ? (
              <Button className="login-button" type="button" onClick={props.handleKerberosLogin} label="Kerberos" />
            ) : null}
          </div>
        </div>
      </Card>
    </form>
  </div>
);

export const LoginForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/login/LoginForm.tsx